import React from 'react';
import { FormGroup, FormControlLabel, Typography, Button } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useFormik } from 'formik';
import PropTypes from 'prop-types';
import { includes, append, without } from 'ramda';
import clsx from 'clsx';

import UserPresenter from 'presenters/UserPresenter';
import StatePresenter from 'presenters/StatePresenter';
import Checkbox from 'sharedComponents/Checkbox';
import useStyles from './useStyles';

const LicensedStatesForm = props => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { onSubmit, currentUser, states } = props;

  const currentValues = UserPresenter.getValuesByFields(currentUser, ['licensedStates']);

  const formik = useFormik({
    initialValues: currentValues,
    onSubmit,
  });

  const { values, handleSubmit, setFieldValue } = formik;

  const handleChange = e => {
    const { checked, value } = e.target;
    if (checked && !includes(value, values.licensedStates)) {
      setFieldValue('licensedStates', append(value, values.licensedStates));
    } else {
      setFieldValue('licensedStates', without([value], values.licensedStates));
    }
  };

  const handleChangeAllControl = e => {
    const { checked } = e.target;
    if (checked) {
      const result = states.map(item => item.value);
      setFieldValue('licensedStates', result);
    } else {
      setFieldValue('licensedStates', []);
    }
  };

  const handleCancel = () => {
    setFieldValue('licensedStates', currentValues.licensedStates);
  };

  return (
    <div className={classes.container}>
      <form onSubmit={handleSubmit}>
        <FormControlLabel
          className={classes.formControl}
          control={<Checkbox onChange={handleChangeAllControl} name="all" />}
          label={
            <Typography variant="body2" className={classes.text}>
              {t('components.LicensedStatesForm.controls.selectAll')}
            </Typography>
          }
        />
        <FormGroup className={classes.group}>
          {states.map(({ label, value, id, active }) => (
            <FormControlLabel
              className={classes.formControl}
              key={id}
              control={
                <Checkbox
                  checked={includes(value, values.licensedStates)}
                  onChange={handleChange}
                  name={value}
                  value={value}
                />
              }
              label={
                <Typography variant="body2" className={clsx(classes.text, { [classes.active]: active })}>
                  {label}
                </Typography>
              }
            />
          ))}
        </FormGroup>
        <div className={classes.buttons}>
          <Button className={classes.button} color="primary" type="submit">
            {t('components.LicensedStatesForm.buttons.save')}
          </Button>
          <Button className={classes.button} onClick={handleCancel} color="primary" variant="outlined" type="button">
            {t('components.LicensedStatesForm.buttons.cancel')}
          </Button>
        </div>
      </form>
    </div>
  );
};

LicensedStatesForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  currentUser: UserPresenter.shape().isRequired,
  states: PropTypes.arrayOf(StatePresenter.shape()).isRequired,
};

export default LicensedStatesForm;



// WEBPACK FOOTER //
// ./src/components/LoanOfficerSettings/components/LicensedStates/components/LicensedStatesForm/LicensedStatesForm.js